module.exports = __webpack_public_path__ + "media/images/tracker/map-6a3020eae9fb6f9b5d42e3de9cafd252.svg";